import get from "lodash/get";
import { getCountryNameByCode } from "src/utils/countryData";

interface CreatorCellValue {
  index: number;
  values: (string | null)[];
}

interface CreatorSearchColumn {
  key: string;
  path: string;
}

interface Influencer {
  socialUsername?: string;
  name?: string;
  [key: string]: any;
}

function getColumnSearchText(
  influencer: Influencer,
  key: string,
  path: string,
): string | null {
  switch (key) {
    case "name": {
      const usernameText = [influencer.socialUsername, influencer.name]
        .filter(Boolean)
        .join(" ");
      return usernameText || null;
    }
    case "country": {
      const country = get(influencer, path);
      if (!country) return null;
      return getCountryNameByCode(country) || country;
    }
    case "recentPosts":
      // Images are not searchable
      return null;
    default: {
      const value = get(influencer, path);
      if (value === null || value === undefined || value === "") return null;
      return String(value);
    }
  }
}

/**
 * Converts a list of influencers to cellTextRows format for useTableSearch.
 * The order of values corresponds to the leading checkbox/preview columns
 * followed by the dynamic columns configured via creatorSearchColumns settings
 * (see CreatorResultRow's LEADING_COLUMNS_COUNT).
 */
export const getCreatorCellValues = (
  influencers: Influencer[],
  columns: CreatorSearchColumn[] = [],
): CreatorCellValue[] => {
  return influencers.map((influencer, index) => {
    const values: (string | null)[] = [];

    // Column 0: checkbox (empty - not searchable)
    values.push(null);

    // Column 1: image preview (empty - not searchable)
    values.push(null);

    columns.forEach(({ key, path }) => {
      values.push(getColumnSearchText(influencer, key, path));
    });

    return {
      index,
      values,
    };
  });
};
